import { z } from "zod";
export const predictiveMaintenanceInsightDtoSchema = z.object({
    alarmId: z.string(),
    date: z.string(),
    alarmStartDate: z.string().nullable(),
    deviceSerialNumber: z.string().nullable(),
    deviceType: z.string().nullable(),
    farmLicenseKey: z.string().nullable(),
    customerNumber: z.string().nullable(),
    customerName: z.string().nullable(),
    serviceAreaId: z.string().nullable(),
    lelyCenterNumber: z.string().nullable(),
    lelyCenterName: z.string().nullable(),
    alarmName: z.string().nullable(),
    alarmCriticality: z.enum(["Critical", "Non critical", "Warning"]),
    alarmScore: z.number().nullable(),
    alarmStatus: z.enum(["Active", "Deactivated"]),
    alarmDescription: z.string().nullable(),
    visitDate: z.string().nullable(),
    feedbackVersion: z.string(),
    feedbackStructure: z.object({
        form: z.object({
            question1: z
                .object({
                label: z.string(),
                options: z.array(z.string()),
            })
                .nullable(),
            question2: z
                .object({
                label: z.string(),
                options: z.array(z.string()),
            })
                .nullable(),
            question3: z
                .object({
                label: z.string(),
                options: z.array(z.string()),
            })
                .nullable(),
            question4: z
                .object({
                label: z.string(),
            })
                .nullable(),
        }),
    }),
});
//# sourceMappingURL=predictive-maintenance.schema.js.map